var map = {
	"./10-Technologies-of-the-Next-Decade-opengraph.png": 15915,
	"./1658484826131-mb-pro-m2-256-wh.jpg": 74702,
	"./637232548612227617_ss-tab-s6-lite-xam-4.webp": 20978,
	"./637232548612897625_ss-tab-s6-lite-xam-5.webp": 89682,
	"./637322132736709615_hp-pavilion-gaming-15-dk-den-1.webp": 64725,
	"./637322132736769740_hp-pavilion-gaming-15-dk-den-2.webp": 29936,
	"./637322132736819654_hp-pavilion-gaming-15-dk-den-3.webp": 68666,
	"./637322132736819654_hp-pavilion-gaming-15-dk-den-4.webp": 14416,
	"./637387847968338274_637335980720863180_asus-zenbook-ux425ja-xam-1.webp": 48057,
	"./637387847968494606_637335980720078468_asus-zenbook-ux425ja-xam-4.webp": 7748,
	"./637387847968494606_637335980720467274_asus-zenbook-ux425ja-xam-2.webp": 37683,
	"./637387847968494606_637335980720682971_asus-zenbook-ux425ja-xam-3.webp": 13822,
	"./637407926277699019_mac-mini-2020-m1-bac-4.jpg": 64452,
	"./637407926277699019_mac-mini-2020-m1-bac-5.jpg": 25327,
	"./637407926278168322_mac-mini-2020-m1-bac-2.jpg": 49481,
	"./637407926278168322_mac-mini-2020-m1-bac-3.jpg": 28179,
	"./637407926278636334_mac-mini-2020-m1-bac-1.jpg": 2591,
	"./637408000894865616_mbp-2020-m1-gray-3.webp": 51038,
	"./637408000894865616_mbp-2020-m1-gray-4.webp": 87784,
	"./637408000895334462_mbp-2020-m1-gray-1.webp": 15839,
	"./637408000895490753_mbp-2020-m1-gray-2.webp": 70003,
	"./637546117379617339_imac-24-silver-1.jpg": 27680,
	"./637577064561286317_ss-tab-a7-lite-xam-3.webp": 87375,
	"./637577064561442620_ss-tab-a7-lite-xam-2.webp": 37830,
	"./637577064561660439_ss-tab-a7-lite-xam-4.webp": 82260,
	"./637577064561995165_ss-tab-a7-lite-xam-1.webp": 87734,
	"./637577064562533153_ss-tab-a7-lite-xam-5.webp": 76330,
	"./637607331807565490_samsung-galaxy-tab-s7-fe-den-4.webp": 2877,
	"./637607331808659176_samsung-galaxy-tab-s7-fe-den-3.webp": 89667,
	"./637607331811315499_samsung-galaxy-tab-s7-fe-den-2.webp": 37055,
	"./637607331811940520_samsung-galaxy-tab-s7-fe-den-1.webp": 60721,
	"./637607331812565519_samsung-galaxy-tab-s7-fe-den-0.webp": 10822,
	"./637609875776726884_hp-22-df0131d-trang-3.jpg": 87383,
	"./637609875778289402_hp-22-df0131d-trang-2.jpg": 22932,
	"./637609875783758205_hp-22-df0131d-trang-1.jpg": 91023,
	"./637618691429168075_lenovo-tab-m10-gen-2-xam-1.webp": 40845,
	"./637618691429324107_lenovo-tab-m10-gen-2-xam-3.webp": 35583,
	"./637618691429480426_lenovo-tab-m10-gen-2-xam-2.webp": 67375,
	"./637618691429480426_lenovo-tab-m10-gen-2-xam-4.webp": 82496,
	"./637618697974134752_lenovo-tab-m10-gen-2-xam-5.webp": 23336,
	"./637618697974446411_lenovo-tab-m10-gen-2-xam-4.webp": 36698,
	"./637618697974758910_lenovo-tab-m10-gen-2-xam-3.webp": 84819,
	"./637618697975071623_lenovo-tab-m10-gen-2-xam-2.webp": 62763,
	"./637618697975227700_lenovo-tab-m10-gen-2-xam-1.webp": 53457,
	"./637649622568371405_xiaomi-redmi-10-trang-1.webp": 92777,
	"./637649622568527630_xiaomi-redmi-10-trang-5.webp": 56193,
	"./637649622571652648_xiaomi-redmi-10-trang-2.webp": 99344,
	"./637649622572433917_xiaomi-redmi-10-trang-3.webp": 46423,
	"./637649622572746346_xiaomi-redmi-10-trang-4.webp": 77615,
	"./637655727922487554_asus-rog-gaming-g513-rgb4-xam-3.webp": 65256,
	"./637655727924518755_asus-rog-gaming-g513-rgb4-xam-1.webp": 53286,
	"./637655727926706226_asus-rog-gaming-g513-rgb4-xam-2.webp": 53102,
	"./637663479325504797_msi-modern-15-xam-3.webp": 92399,
	"./637663479326129766_msi-modern-15-xam-2.webp": 89172,
	"./637663479326285995_msi-modern-15-xam-4.webp": 56652,
	"./637663479331129814_msi-modern-15-xam-1 copy.webp": 49764,
	"./637663479331129814_msi-modern-15-xam-1.webp": 46058,
	"./637663502046420264_hp-zbook-firefly-14-g8-xam-4.webp": 11995,
	"./637663502047201460_hp-zbook-firefly-14-g8-xam-2.webp": 49202,
	"./637663502047357766_hp-zbook-firefly-14-g8-xam-3.webp": 63771,
	"./637663502050170145_hp-zbook-firefly-14-g8-xam-1.webp": 40274,
	"./637683516026005964_acer-predator-helios-gaming-ph315-54-den-1.webp": 28558,
	"./637683516027568465_acer-predator-helios-gaming-ph315-54-den-4.webp": 70609,
	"./637683516029287187_acer-predator-helios-gaming-ph315-54-den-3.webp": 10279,
	"./637683516031318532_acer-predator-helios-gaming-ph315-54-den-2.webp": 92930,
	"./637684185938066737_mt-aio-asus-v222fak-den-1.jpg": 31094,
	"./637684185938066737_mt-aio-asus-v222fak-den-2.jpg": 82554,
	"./637684213467621890_mt-aio-asus-e5-den-1.jpg": 17021,
	"./637692066783854040_xiaomi-11t-pro-xam-5.webp": 41083,
	"./637692066784322804_xiaomi-11t-pro-xam-3.webp": 52968,
	"./637692066784479155_xiaomi-11t-pro-xam-2.webp": 54074,
	"./637692066784791588_xiaomi-11t-pro-xam-1.webp": 19592,
	"./637692066784791588_xiaomi-11t-pro-xam-4.webp": 7776,
	"./637702682505958965_macbook-pro-16-2021-xam-3.webp": 52028,
	"./637702682507677814_macbook-pro-16-2021-xam-2.webp": 25601,
	"./637702682508615222_macbook-pro-16-2021-xam-1.webp": 15605,
	"./637702682511584031_macbook-pro-16-2021-xam-4.webp": 82243,
	"./637725810551806112_may-tinh-bang-masstel-tab-10m-4g-xanh-navy-4.webp": 67365,
	"./637725810554462380_may-tinh-bang-masstel-tab-10m-4g-xanh-navy-1.webp": 43482,
	"./637725810559931216_may-tinh-bang-masstel-tab-10m-4g-xanh-navy-2.webp": 15066,
	"./637725810559931216_may-tinh-bang-masstel-tab-10m-4g-xanh-navy-3.webp": 51168,
	"./637727610205542057_asus-zenbook-flip-ux363-xam-4.webp": 97063,
	"./637727610205698348_asus-zenbook-flip-ux363-xam-3.webp": 93720,
	"./637727610206010780_asus-zenbook-flip-ux363-xam-1.webp": 52384,
	"./637727610206010780_asus-zenbook-flip-ux363-xam-2.webp": 30162,
	"./637743875018622318_acer-nitro-gaming-an515-57-56xx-den-4.webp": 46774,
	"./637743875018934829_acer-nitro-gaming-an515-57-56xx-den-3.webp": 99775,
	"./637743875019403625_acer-nitro-gaming-an515-57-56xx-den-1.webp": 71941,
	"./637743875019403625_acer-nitro-gaming-an515-57-56xx-den-2.webp": 37432,
	"./637762872891630450_hp-prodesk-400g6-den-1.jpg": 27570,
	"./637762931116691737_hp-prodesk-400g6-den-2 (1).jpg": 67096,
	"./637762931116848015_hp-prodesk-400g6-den-3 (1).jpg": 98120,
	"./637764585583795188_asus-vivobook-pro-m3401qa-bac-5.webp": 8400,
	"./637764585584576434_asus-vivobook-pro-m3401qa-bac-1.webp": 60254,
	"./637764585586295124_asus-vivobook-pro-m3401qa-bac-4.webp": 40537,
	"./637764585587232674_asus-vivobook-pro-m3401qa-bac-3.webp": 9202,
	"./637772299856460886_samsung-galaxy-tab-a8-xam-5.webp": 64704,
	"./637772299857554683_samsung-galaxy-tab-a8-xam-3.webp": 37388,
	"./637772299857867551_samsung-galaxy-tab-a8-xam-1.webp": 94036,
	"./637772299857867551_samsung-galaxy-tab-a8-xam-2.webp": 5065,
	"./637772299858648454_samsung-galaxy-tab-a8-xam-4.webp": 2739,
	"./637775083720823374_lenovo-yoga-7-14acn6-xam-1.webp": 8377,
	"./637775083720823374_lenovo-yoga-7-14acn6-xam-3.webp": 72237,
	"./637775083720823374_lenovo-yoga-7-14acn6-xam-4.webp": 3170,
	"./637775083721135869_lenovo-yoga-7-14acn6-xam-2.webp": 59670,
	"./637783716924049932_asus-s500sc-den-1.jpg": 67074,
	"./637783716924518653_asus-s500sc-den-6.jpg": 12726,
	"./637783716927174996_asus-s500sc-den-3.jpg": 52275,
	"./637783716927174996_asus-s500sc-den-5.jpg": 13941,
	"./637783716928737511_asus-s500sc-den-4.jpg": 72331,
	"./637783716933425210_asus-s500sc-den-2.jpg": 69383,
	"./637784648681291910_acer-swift-3-sf314-511-bac-4.webp": 24805,
	"./637784648681448154_acer-swift-3-sf314-511-bac-2.webp": 65117,
	"./637784648681448154_acer-swift-3-sf314-511-bac-3.webp": 19263,
	"./637784648681916953_acer-swift-3-sf314-511-bac-1.webp": 88409,
	"./637800820553643769_samsung-galaxy-tab-s8-xam-3.webp": 10514,
	"./637800820553956232_samsung-galaxy-tab-s8-xam-6.webp": 94050,
	"./637800820554424975_samsung-galaxy-tab-s8-xam-1.webp": 20866,
	"./637800820555050150_samsung-galaxy-tab-s8-xam-2.webp": 49500,
	"./637800820555050150_samsung-galaxy-tab-s8-xam-7.webp": 93006,
	"./637800820555362608_samsung-galaxy-tab-s8-xam-4.webp": 89090,
	"./637800820555362608_samsung-galaxy-tab-s8-xam-5.webp": 46309,
	"./637817435459912672_acer-nitro-gaming-an515-58-den-2.webp": 24210,
	"./637817435462881696_acer-nitro-gaming-an515-58-den-4.webp": 82679,
	"./637817435465226004_acer-nitro-gaming-an515-58-den-3.webp": 11895,
	"./637817435466475076_acer-nitro-gaming-an515-58-den-1.webp": 15235,
	"./637824229906952678_mac-studio-2022-bac-3.jpg": 74121,
	"./637824229907421423_mac-studio-2022-bac-2.jpg": 26311,
	"./637824229907890199_mac-studio-2022-bac-1.jpg": 70866,
	"./637824229913671542_mac-studio-2022-bac-4.jpg": 83496,
	"./637830415222444875_xiaomi-redmi-10c-4gb-128gb-xanh-2.webp": 91175,
	"./637830415222601150_xiaomi-redmi-10c-4gb-128gb-xanh-1.webp": 84811,
	"./637830415224476121_xiaomi-redmi-10c-4gb-128gb-xanh-3.webp": 63941,
	"./637830415224788599_xiaomi-redmi-10c-4gb-128gb-xanh-4.webp": 43812,
	"./637845969082903356_Mac mini 2020 M1 256GB SSD MGNR3SAA (1).jpg": 47789,
	"./637845969083059624_Mac mini 2020 M1 256GB SSD MGNR3SAA (3).jpg": 86945,
	"./637845969083215955_Mac mini 2020 M1 256GB SSD MGNR3SAA (2).jpg": 77177,
	"./637845969083215955_Mac mini 2020 M1 256GB SSD MGNR3SAA (4).jpg": 7869,
	"./637845969083528403_Mac mini 2020 M1 256GB SSD MGNR3SAA (6).jpg": 32586,
	"./637846093546558931_iMac 24 2021 Retina 45K M18-Core CPU7-Core GPU8GB256GB SSD (1).jpg": 4013,
	"./637846093546715146_iMac 24 2021 Retina 45K M18-Core CPU7-Core GPU8GB256GB SSD (2).jpg": 89468,
	"./637846093546715146_iMac 24 2021 Retina 45K M18-Core CPU7-Core GPU8GB256GB SSD (4).jpg": 42670,
	"./637846093546871494_iMac 24 2021 Retina 45K M18-Core CPU7-Core GPU8GB256GB SSD (3).jpg": 64805,
	"./637846093548121524_iMac 24 2021 Retina 45K M18-Core CPU7-Core GPU8GB256GB SSD (7).jpg": 26701,
	"./637846093548746496_iMac 24 2021 Retina 45K M18-Core CPU7-Core GPU8GB256GB SSD (8) copy.jpg": 50168,
	"./637846093548746496_iMac 24 2021 Retina 45K M18-Core CPU7-Core GPU8GB256GB SSD (8).jpg": 11082,
	"./637846093549371523_iMac 24 2021 Retina 45K M18-Core CPU7-Core GPU8GB256GB SSD (6).jpg": 14135,
	"./637849354240568281_samsung-galaxy-a73-xanh-5 copy.webp": 28544,
	"./637849354240568281_samsung-galaxy-a73-xanh-5.webp": 49621,
	"./637849354241193441_samsung-galaxy-a73-xanh-3.webp": 99015,
	"./637849354241818312_samsung-galaxy-a73-xanh-1.webp": 74935,
	"./637849354241818312_samsung-galaxy-a73-xanh-2.webp": 75768,
	"./637849354241974615_samsung-galaxy-a73-xanh-4.webp": 85102,
	"./637850092510395816_asus-tuf-gaming-fx506h-den-3.webp": 66629,
	"./637850092510552100_asus-tuf-gaming-fx506h-den-2.webp": 44509,
	"./637850092511020843_asus-tuf-gaming-fx506h-den-1.webp": 43632,
	"./637850092511020843_asus-tuf-gaming-fx506h-den-4.webp": 95701,
	"./637859621022242193_Mac Studio 2022 M1 Ultra64GB1TB SSD (3).jpg": 18742,
	"./637859621022242193_Mac Studio 2022 M1 Ultra64GB1TB SSD (4).jpg": 9447,
	"./637859621022554682_Mac Studio 2022 M1 Ultra64GB1TB SSD (2).jpg": 36751,
	"./637859621022710976_Mac Studio 2022 M1 Ultra64GB1TB SSD (1).jpg": 72942,
	"./637859751770824458_iphone-13-pro-max-xam-2.webp": 62178,
	"./637859751770824458_iphone-13-pro-max-xam-3.webp": 59209,
	"./637859751770824458_iphone-13-pro-max-xam-5.webp": 58701,
	"./637859751770980691_iphone-13-pro-max-xam-1.webp": 28437,
	"./637859752824294356_iphone-13-pro-max-xam-4.webp": 56897,
	"./637884897848739858_samsung-galaxy-tab-s8-ultra-5.webp": 90955,
	"./637884897848896178_samsung-galaxy-tab-s8-ultra-3.webp": 6888,
	"./637884897848896178_samsung-galaxy-tab-s8-ultra-4.webp": 67947,
	"./637884897849677473_samsung-galaxy-tab-s8-ultra-1.webp": 99234,
	"./637884897849833687_samsung-galaxy-tab-s8-ultra-2.webp": 48012,
	"./637889803064591061_hp-gaming-omen-16-den-2.webp": 77703,
	"./637889803064591061_hp-gaming-omen-16-den-4.webp": 42022,
	"./637889803064747112_hp-gaming-omen-16-den-1.webp": 77433,
	"./637889803064747112_hp-gaming-omen-16-den-3.webp": 99057,
	"./637890985840900515_lenovo-yoga-slim-7-pro-14ihu5-bac-1.webp": 14600,
	"./637890991628427881_lenovo-yoga-slim-7-pro-14ihu5-bac-3.webp": 42056,
	"./637890991628584335_lenovo-yoga-slim-7-pro-14ihu5-bac-2.webp": 50753,
	"./637901935594127150_macbook-pro-m2-2022-xam-1.webp": 41878,
	"./637901982829449243_macbook-pro-m2-2022-xam-2.webp": 45463,
	"./637901982830230338_macbook-pro-m2-2022-xam-3.webp": 30748,
	"./637910569083881950_oppo-a57-den-1.webp": 60388,
	"./637910569084038088_oppo-a57-den-5.webp": 51364,
	"./637919437068621162_oppo-a57-den-3.webp": 38566,
	"./637931279962223378_samsung-galaxy-tab-s6-lite-2022-den-7.webp": 86372,
	"./637931279962692192_samsung-galaxy-tab-s6-lite-2022-den-8.webp": 34235,
	"./637931279962692192_samsung-galaxy-tab-s6-lite-2022-den-9.webp": 2528,
	"./637931279963004703_samsung-galaxy-tab-s6-lite-2022-den-6.webp": 37249,
	"./637941779746995258_samsung-galaxy-s22-bora-purple-3.webp": 62301,
	"./637941779748870189_samsung-galaxy-s22-bora-purple-2.webp": 51984,
	"./637941779749182644_samsung-galaxy-s22-bora-purple-4.webp": 85563,
	"./637941779749495327_samsung-galaxy-s22-bora-purple-1.webp": 37662,
	"./637947168657122564_hp-pavilion-14-dv-win11-vang-4.webp": 38147,
	"./637947168657435002_hp-pavilion-14-dv-win11-vang-1.webp": 17803,
	"./637947168657435002_hp-pavilion-14-dv-win11-vang-2.webp": 83350,
	"./637947168657435002_hp-pavilion-14-dv-win11-vang-3.webp": 38003,
	"./637951440971766327_lenovo-yoga-slim-7-pro-14ihu5-bac-4.webp": 7555,
	"./637953963684710392_oppo-pad-air-5.webp": 98571,
	"./637953963685335528_oppo-pad-air-3.webp": 16754,
	"./637953963685335528_oppo-pad-air-4.webp": 91901,
	"./637953964743478927_oppo-pad-air-2.webp": 35821,
	"./637953964748166251_oppo-pad-air-1.webp": 18384,
	"./637957658354316100_samsung-galaxy-z-flip4-tim-1.webp": 43438,
	"./637957703260561099_samsung-galaxy-z-flip4-tim-3.webp": 36968,
	"./637957703261029822_samsung-galaxy-z-flip4-tim-5.webp": 11025,
	"./637957703261967280_samsung-galaxy-z-flip4-tim-2.webp": 5082,
	"./637957703262279890_samsung-galaxy-z-flip4-tim-4.webp": 83553,
	"./637957721234751791_samsung-galaxy-z-fold4-kem-6.webp": 87433,
	"./637957721235689301_samsung-galaxy-z-fold4-kem-4.webp": 58000,
	"./637957721237095589_samsung-galaxy-z-fold4-kem-5.webp": 26820,
	"./637957721237564298_samsung-galaxy-z-fold4-kem-1.webp": 12524,
	"./637957721237720533_samsung-galaxy-z-fold4-kem-2.webp": 78863,
	"./637957721238501939_samsung-galaxy-z-fold4-kem-3.webp": 10159,
	"./637974781891688457_xiaomi-redmi-10-den-3.webp": 10711,
	"./637974781895126878_xiaomi-redmi-10-den-1.webp": 83560,
	"./637974781895439247_xiaomi-redmi-10-den-2.webp": 24248,
	"./637974781898407535_xiaomi-redmi-10-den-4.webp": 29899,
	"./637982295031330586_oppo-find-x5-pro-trang-1.webp": 83818,
	"./637982295031330586_oppo-find-x5-pro-trang-2.webp": 90037,
	"./637982295033674392_oppo-find-x5-pro-trang-4.webp": 90466,
	"./637982295033986858_oppo-find-x5-pro-trang-3.webp": 38072,
	"./637982295035080684_oppo-find-x5-pro-trang-5.webp": 50247,
	"./637987719189627753_asus-vivobook-m1403-non-oled-bac-3.webp": 50403,
	"./637987719191346214_asus-vivobook-m1403-non-oled-bac-2.webp": 29122,
	"./637987719191658652_asus-vivobook-m1403-non-oled-bac-1.webp": 43615,
	"./637987719191814975_asus-vivobook-m1403-non-oled-bac-4.webp": 94512,
	"./637998708770319266_oppo-a57-den-4.webp": 94517,
	"./637998708771256795_oppo-a57-den-2.webp": 72166,
	"./637999616466254442_lenovo-thinkpad-e14-gen-4-i5-1235u-den-3.webp": 56556,
	"./637999616466723278_lenovo-thinkpad-e14-gen-4-i5-1235u-den-4.webp": 46185,
	"./637999616466879436_lenovo-thinkpad-e14-gen-4-i5-1235u-den-2.webp": 87286,
	"./637999616467035700_lenovo-thinkpad-e14-gen-4-i5-1235u-den-1.webp": 25126,
	"./638000430280752613_asus-vivobook-flip-tp3402-bac-3.webp": 99028,
	"./638000430282315086_asus-vivobook-flip-tp3402-bac-2 copy.webp": 74305,
	"./638000430282315086_asus-vivobook-flip-tp3402-bac-2.webp": 45220,
	"./638000430282627835_asus-vivobook-flip-tp3402-bac-1.webp": 48717,
	"./638000430282783913_asus-vivobook-flip-tp3402-bac-6.webp": 91668,
	"./638000702150910572_lenovo-ideacentre-aio-3-24itl6-i3-1115g4-ram-4gb-den-4.jpg": 75418,
	"./638000702151692106_lenovo-ideacentre-aio-3-24itl6-i3-1115g4-ram-4gb-den-1.jpg": 5944,
	"./638000702151692106_lenovo-ideacentre-aio-3-24itl6-i3-1115g4-ram-4gb-den-2 (1).jpg": 80843,
	"./638000702151848101_lenovo-ideacentre-aio-3-24itl6-i3-1115g4-ram-4gb-den-3 (1).jpg": 43531,
	"./638000729084328690_hp-pavilion-tp01-3008d-trang-1.jpg": 38538,
	"./638005672570287108_oppo-a77s-den-1.webp": 73158,
	"./638005672570755785_oppo-a77s-den-3.webp": 83391,
	"./638005897365111890_oppo-a77s-den-4.webp": 79588,
	"./638005897365893263_oppo-a77s-den-2.webp": 87519,
	"./638005897366049263_oppo-a77s-den-5.webp": 34363,
	"./638007368710444071_msi-gaming-gf63-thin-11sc-1090vn-den-1.webp": 35170,
	"./638011026555751243_lenovo-thinkpad-e14-gen-4-den-3.webp": 85885,
	"./638011026555751243_lenovo-thinkpad-e14-gen-4-den-4.webp": 12764,
	"./638011026555853473_lenovo-thinkpad-e14-gen-4-den-1.webp": 18464,
	"./638011026555853473_lenovo-thinkpad-e14-gen-4-den-2.webp": 54758,
	"./638016267842487404_oppo-a17-den-1.webp": 4218,
	"./638016278087001775_oppo-a17-den-5.webp": 77940,
	"./638016278092104929_oppo-a17-den-2.webp": 73216,
	"./638016278092261070_oppo-a17-den-3.webp": 46488,
	"./638016278093338357_oppo-a17-den-4.webp": 19086,
	"./638017841584664118_msi-gaming-katana-gf66-12u-den-3.webp": 8552,
	"./638017841584664118_msi-gaming-katana-gf66-12u-den-4.webp": 86796,
	"./638017841585071699_msi-gaming-katana-gf66-12u-den-1.webp": 91726,
	"./638017841585583091_msi-gaming-katana-gf66-12u-den-2.webp": 24550,
	"./638018713258244488_lenovo-gaming-legion-5-15arh7-xam-dam-4.webp": 94122,
	"./638018713258556936_lenovo-gaming-legion-5-15arh7-xam-dam-3.webp": 5087,
	"./638018713259338198_lenovo-gaming-legion-5-15arh7-xam-dam-2.webp": 3790,
	"./638018713259494423_lenovo-gaming-legion-5-15arh7-xam-dam-1.webp": 77595,
	"./638041282329466097_HASP-EPOWER-F1650-2.webp": 34157,
	"./638041282329466097_HASP-EPOWER-F1650-3.webp": 13987,
	"./638041282330559957_HASP-EPOWER-F1650-9.webp": 2106,
	"./638041282330872604_HASP-EPOWER-F1650-1.webp": 59401,
	"./638041282331341232_HASP-EPOWER-F1650-7.webp": 28192,
	"./638041282331497383_HASP-EPOWER-F1650-4.webp": 92720,
	"./638041282331941670_HASP-EPOWER-F1650-5.webp": 45431,
	"./638041282332409521_HASP-EPOWER-F1650-10.webp": 90281,
	"./638041282332409521_HASP-EPOWER-F1650-8.webp": 80808,
	"./638041282332572205_HASP-EPOWER-F1650-6.webp": 16456,
	"./638046361535750788_lenovo-tab-m10-gen-3-xam-2.webp": 81149,
	"./638046361535750788_lenovo-tab-m10-gen-3-xam-3.webp": 26195,
	"./638046361536219624_lenovo-tab-m10-gen-3-xam-5.webp": 13593,
	"./638046361536701393_lenovo-tab-m10-gen-3-xam-4.webp": 8470,
	"./638046361537170967_lenovo-tab-m10-gen-3-xam-1.webp": 61222,
	"./638048985101352420_xiaomi-redmi-pad-xam-3.webp": 6975,
	"./638048985101666856_xiaomi-redmi-pad-xam-1.webp": 47971,
	"./638048985101984297_xiaomi-redmi-pad-xam-2.webp": 43985,
	"./638048985101984297_xiaomi-redmi-pad-xam-4.webp": 54651,
	"./638054166106341023_ip-14-plus-do-1.webp": 35543,
	"./638054218956629637_ip-14-pro-max-den-1.webp": 19210,
	"./638058452662264686_ipad-air-5-wf-5g-vang-1.webp": 33027,
	"./638058452662420873_ipad-air-5-wf-5g-vang-2.webp": 35994,
	"./638058452663673652_ipad-air-5-wf-5g-vang-4.webp": 52417,
	"./638058452688601459_ipad-air-5-wf-5g-vang-3.webp": 11265,
	"./638058452872160200_ipad-air-5-wf-5g-xanh-6.webp": 48770,
	"./638058452872316835_ipad-air-5-wf-5g-xanh-7.webp": 36511,
	"./638058452889518721_ipad-air-5-wf-5g-xanh-5.webp": 87972,
	"./638058485549424901_iPad Gen 9 bac -2.webp": 36215,
	"./638058485549424901_iPad Gen 9 bac -3.webp": 18737,
	"./638058485549581174_iPad Gen 9 bac -1.webp": 51959,
	"./638058485549737504_iPad Gen 9 bac -5.webp": 34628,
	"./638058485550049893_iPad Gen 9 bac -4.webp": 26205,
	"./638058527734877284_ipad-pro-11-m1-wifi-bac-4.webp": 2427,
	"./638058527735508214_ipad-pro-11-m1-wifi-bac-3.webp": 85876,
	"./638058527735508214_ipad-pro-11-m1-wifi-bac-6.webp": 81969,
	"./638058527735827543_ipad-pro-11-m1-wifi-bac-2.webp": 69413,
	"./638058527735983795_ipad-pro-11-m1-wifi-bac-5.webp": 56569,
	"./638058527736303163_ipad-pro-11-m1-wifi-bac-1.webp": 55810,
	"./638058527738665492_ipad-pro-11-m1-wifi-bac-7.webp": 72115,
	"./638059237852757989_iphone-12-xanhla-3.webp": 36078,
	"./638059237852920204_iphone-12-xanhla-5.webp": 94491,
	"./638059237853083337_iphone-12-xanhla-2.webp": 47169,
	"./638059237853240136_iphone-12-xanhla-1.webp": 3478,
	"./638059237853240136_iphone-12-xanhla-4.webp": 56450,
	"./638059237853240136_iphone-12-xanhla-6.webp": 36027,
	"./638059237855486250_iphone-12-xanhla-7.webp": 32964,
	"./638059237856756405_iphone-12-xanhla-10.webp": 77013,
	"./638059237856756405_iphone-12-xanhla-8.webp": 46725,
	"./638059237856756405_iphone-12-xanhla-9.webp": 99381,
	"./638059319531070180_ipad-mini-6-wifi-xam-6.webp": 60918,
	"./638059319531382608_ipad-mini-6-wifi-xam-1.webp": 82899,
	"./638059319531382608_ipad-mini-6-wifi-xam-4.webp": 58143,
	"./638059319531657137_ipad-mini-6-wifi-xam-3.webp": 78844,
	"./638059319531682592_ipad-mini-6-wifi-xam-2.webp": 55772,
	"./638059319532141743_ipad-mini-6-wifi-xam-5.webp": 42445,
	"./638059319533711679_ipad-mini-6-wifi-xam-7.webp": 40179,
	"./638059319534812324_ipad-mini-6-wifi-xam-8.webp": 21267,
	"./638059477189671553_iPad-Gen-9-bac--6.webp": 59755,
	"./638096359387527669_mac-mini-2023-m2-2.jpg": 51824,
	"./638096359387527669_mac-mini-2023-m2-4.jpg": 81109,
	"./638096359388004765_mac-mini-2023-m2-1.jpg": 5195,
	"./638096359388317309_mac-mini-2023-m2-6.jpg": 75962,
	"./638096359388473379_mac-mini-2023-m2-3.jpg": 70726,
	"./638096359390529103_mac-mini-2023-m2-5.jpg": 59730,
	"./638096554107607142_00854280-E-Power Office 17-1.webp": 28528,
	"./638096554108178257_00854280-E-Power Office 17-2.webp": 97802,
	"./638096554108485196_00854274-E-Power Office 16.webp": 38039,
	"./638096554113216539_00854272 E-Power Office 15.webp": 58303,
	"./638096554115373578_00854280-E-Power Office 17-3.webp": 7342,
	"./638096554165608616_00854280-E-Power Office 17-4.webp": 74753,
	"./638096554171176189_00854280-E-Power Office 17-5.webp": 34522,
	"./638106988528390612_oppo-reno8-t-5g-vang-4.webp": 16881,
	"./638106988530845194_oppo-reno8-t-5g-vang-1.webp": 50996,
	"./638107712753851371_pc-gaming-e-power-i5g11-3060ti-i5-11400f-den-1.jpg": 65363,
	"./638108941585078058_samsung-galaxy-s23-ultra-den-1.webp": 20223,
	"./638109273683143201_lenovo-gaming-legion-5-15iah7h-i7-12700h-5.webp": 49701,
	"./638109273683768082_lenovo-gaming-legion-5-15iah7h-i7-12700h-4.webp": 19680,
	"./638109273684081374_lenovo-gaming-legion-5-15iah7h-i7-12700h-3.webp": 75954,
	"./638109273684237034_lenovo-gaming-legion-5-15iah7h-i7-12700h-2.webp": 88,
	"./638109316751980743_asus-vivobook-m513ua-ej704w-r7-5700u-bac-5.webp": 64180,
	"./638109316752447576_asus-vivobook-m513ua-ej704w-r7-5700u-bac-2.webp": 24476,
	"./638109316756162583_asus-vivobook-m513ua-ej704w-r7-5700u-bac-1.webp": 69480,
	"./638109316757538562_asus-vivobook-m513ua-ej704w-r7-5700u-bac-4.webp": 66349,
	"./638109492829105392_oppo-reno8-t-5g-vang-3.webp": 70197,
	"./638109492832529871_oppo-reno8-t-5g-vang-2.webp": 57898,
	"./638109492842561801_oppo-reno8-t-5g-vang-5.webp": 97870,
	"./638120655160772891_asus-gaming-rog-strix-g634jz-n4029w-den-2.webp": 97340,
	"./638120655160822385_asus-gaming-rog-strix-g634jz-n4029w-den-3.webp": 35445,
	"./638120655160846619_asus-gaming-rog-strix-g634jz-n4029w-den-1.webp": 65149,
	"./638120655160883550_asus-gaming-rog-strix-g634jz-n4029w-den-4.webp": 71829,
	"./638122552530025434_samsung-galaxy-s23-ultra-den-6.webp": 75888,
	"./638122552530982554_samsung-galaxy-s23-ultra-den-5.webp": 4832,
	"./638122552531139428_samsung-galaxy-s23-ultra-den-3.webp": 70515,
	"./638122552532122734_samsung-galaxy-s23-ultra-den-2.webp": 35284,
	"./638122552532435910_samsung-galaxy-s23-ultra-den-4.webp": 5239,
	"./638127667775140076_iphone-14-plus-5.webp": 56581,
	"./638127667775616514_iphone-14-plus-3.webp": 69180,
	"./638127667775949738_iphone-14-plus-2.webp": 22068,
	"./638127667776112348_iphone-14-plus-1.webp": 41187,
	"./638127667776112348_iphone-14-plus-4.webp": 93191,
	"./638127667975460962_iphone-14-plus-do-5.webp": 20525,
	"./638129176875910469_iphone-14pro-14prm-2.webp": 56544,
	"./638129176877496345_iphone-14promax-1.webp": 61103,
	"./638129176877756103_iphone-14pro-14prm-4.webp": 55986,
	"./638129176880563423_iphone-14pro-14prm-3.webp": 20340,
	"./638129177601274543_iphone-14prm-den-1.webp": 39454,
	"./638131034514596031_asus-a3402wbak-wa066w-i5-1235u-trang-3.jpg": 26526,
	"./638131034515276164_asus-a3402wbak-wa066w-i5-1235u-trang-2.jpg": 82709,
	"./638131034515596577_asus-a3402wbak-wa066w-i5-1235u-trang-4.jpg": 77103,
	"./638131034515596577_asus-a3402wbak-wa066w-i5-1235u-trang-5.jpg": 39972,
	"./638131034515917961_asus-a3402wbak-wa066w-i5-1235u-trang-1.jpg": 89419,
	"./638131068637567604_pc-gaming-e-power-g1650-i3-10100f-500w-5.jpg": 84434,
	"./638131068637567604_pc-gaming-e-power-g1650-i3-10100f-500w-5.webp": 12646,
	"./638131068637976057_pc-gaming-e-power-g1650-i3-10100f-500w-2.jpg": 73030,
	"./638131068637976057_pc-gaming-e-power-g1650-i3-10100f-500w-2.webp": 89501,
	"./638131068638340692_pc-gaming-e-power-g1650-i3-10100f-500w-3.jpg": 68502,
	"./638131068638340692_pc-gaming-e-power-g1650-i3-10100f-500w-3.webp": 34873,
	"./638131068638648273_pc-gaming-e-power-g1650-i3-10100f-500w-4.jpg": 76751,
	"./638131068638648273_pc-gaming-e-power-g1650-i3-10100f-500w-4.webp": 24623,
	"./638131068638756332_pc-gaming-e-power-g1650-i3-10100f-500w-1.jpg": 33221,
	"./638131068638756332_pc-gaming-e-power-g1650-i3-10100f-500w-1.webp": 26657,
	"./638138646674627859_xiaomi-redmi-12c-xam-4.webp": 30879,
	"./638138646674864025_xiaomi-redmi-12c-xam-2.webp": 80840,
	"./638138646675115995_xiaomi-redmi-12c-xam-3.webp": 53920,
	"./638138646675311035_xiaomi-redmi-12c-xam-1.webp": 18586,
	"./638138921565687118_iphone-14-do-7.webp": 46067,
	"./638138921570765389_iphone-14-do-4.webp": 30629,
	"./638139579497269864_iphone-14pro-den-5.webp": 97032,
	"./638139579498434541_iphone-14pro-den-4.webp": 9916,
	"./68(1).webp": 11335,
	"./68(2).webp": 74884,
	"./HP-Pavilion-TP01-2022-white-1 (1).jpg": 22158,
	"./HP-Pavilion-TP01-2022-white-2 (1).jpg": 34094,
	"./HP-Pavilion-TP01-2022-white-3 (1).jpg": 25508,
	"./HP-ProDesk-400G6-2 (1).jpg": 39993,
	"./Lenovo-IdeaCentre-AIO-3-24ITL6-black-7.jpg": 45526,
	"./Lenovo-IdeaCentre-AIO-3-24ITL6-black-8 (1).jpg": 37207,
	"./Linkking.png": 75453,
	"./Logo.png": 96607,
	"./Logo.svg": 10953,
	"./Required.svg": 3928,
	"./Xigmatek-NYM-2F-1.jpg": 12684,
	"./Xigmatek-NYM-2F-2.jpg": 19549,
	"./acre.webp": 41517,
	"./apple.png": 81119,
	"./apple.svg": 82350,
	"./asus-rog-gaming-g513-rgb4-xam-4-transformed.jpeg": 96283,
	"./asus.webp": 59850,
	"./background.svg": 95892,
	"./banner.jpg": 46599,
	"./banner1.jpg": 82464,
	"./banner2.png": 6556,
	"./banner3.png": 40084,
	"./banner4.png": 78472,
	"./banner5.png": 83223,
	"./card2.jpeg": 38733,
	"./card3.png": 14291,
	"./card4.png": 72409,
	"./card5.jpeg": 16482,
	"./card6.png": 64675,
	"./card7.jpeg": 80028,
	"./change-password.png": 75500,
	"./clipse.svg": 37695,
	"./cod.svg": 99055,
	"./coolpad.png": 96262,
	"./dell.webp": 58916,
	"./e-power.webp": 60609,
	"./empty-cart.png": 3656,
	"./flagEN.svg": 13677,
	"./flagVN.svg": 8109,
	"./ft-img1.png": 50537,
	"./ft-img10.png": 58028,
	"./ft-img11.png": 78450,
	"./ft-img12.png": 2557,
	"./ft-img13.png": 76827,
	"./ft-img14.png": 71093,
	"./ft-img15.png": 93636,
	"./ft-img2.png": 70019,
	"./ft-img3.png": 27404,
	"./ft-img4.png": 19267,
	"./ft-img5.png": 59735,
	"./ft-img6.png": 26683,
	"./ft-img7.png": 81766,
	"./ft-img8.png": 76230,
	"./ft-img9.png": 71448,
	"./gaming.webp": 12046,
	"./gigabyte.png": 13708,
	"./hp-all-in-one-24-3.jpg": 51402,
	"./hp-all-in-one-24-8.jpg": 6382,
	"./hp.webp": 70930,
	"./icon-pc.png": 97799,
	"./icon-saleoff.webp": 97786,
	"./imac.webp": 97836,
	"./img-location.png": 46384,
	"./img-no-result.png": 69648,
	"./img-noti.png": 3341,
	"./img-user.png": 12189,
	"./iphone.webp": 80836,
	"./item1.png": 7356,
	"./item2.png": 49301,
	"./item3.png": 79976,
	"./item4.png": 64482,
	"./item5.jpeg": 3549,
	"./item6.png": 91910,
	"./item7.png": 50853,
	"./laptop.jpeg": 62724,
	"./lenovo.png": 85836,
	"./lock.svg": 23006,
	"./macmini.webp": 26426,
	"./mail.svg": 36829,
	"./masstel.png": 20628,
	"./momo.png": 64774,
	"./msi.png": 30014,
	"./msi.svg": 89576,
	"./nokia.webp": 92922,
	"./notFound.webp": 79355,
	"./noti-search.png": 52710,
	"./oppo.webp": 77499,
	"./pc.png": 65896,
	"./realme.webp": 61162,
	"./redmi.webp": 50220,
	"./samsung.webp": 77592,
	"./screen.png": 56043,
	"./slider1.svg": 44569,
	"./slider2.svg": 84310,
	"./slider3.svg": 24754,
	"./slideshow_10.png": 57556,
	"./slideshow_11.jpeg": 25582,
	"./slideshow_12.jpeg": 35421,
	"./slideshow_13 - Copy (2).webp": 54326,
	"./slideshow_13 - Copy (3).webp": 60924,
	"./slideshow_13 - Copy.webp": 72073,
	"./slideshow_13.webp": 85709,
	"./slideshow_7.jpeg": 39779,
	"./slideshow_8.jpeg": 94571,
	"./technology-in-the-workplace.png": 97321,
	"./text_ng_n_11__1_6.webp": 93785,
	"./text_ng_n_12__12.webp": 98551,
	"./text_ng_n_13__13.webp": 30947,
	"./type-gaming.png": 46129,
	"./user.svg": 13816,
	"./vivo.webp": 31829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;